import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { NotAuthorisedComponent } from './not-authorised/not-authorised.component';



@NgModule({
  declarations: [
    PageNotFoundComponent,
    NotAuthorisedComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    PageNotFoundComponent,
    NotAuthorisedComponent
  ]
})
export class ViewsModule { }
